import type {
  CreateMapNoteInput,
  MapNote,
  UpdateMapNoteInput,
} from "@west-marches/shared";
import { apiFetch } from "@/lib/apiClient";

async function readJson<T>(response: Response): Promise<T> {
  const payload = (await response.json().catch(() => ({}))) as T & {
    error?: string;
  };

  if (!response.ok) {
    const message =
      typeof payload.error === "string" && payload.error ? payload.error : "Request failed";
    throw new Error(message);
  }

  return payload;
}

export async function listCampaignMapNotes(
  campaignId: string,
  options: { asPlayer?: boolean } = {},
): Promise<MapNote[]> {
  const params = options.asPlayer ? "?asPlayer=1" : "";
  const response = await apiFetch(
    `/api/campaigns/${encodeURIComponent(campaignId)}/map-notes${params}`,
    { method: "GET" },
  );
  const payload = await readJson<{ mapNotes: MapNote[] }>(response);
  return payload.mapNotes;
}

export async function createCampaignMapNote(
  campaignId: string,
  input: CreateMapNoteInput,
): Promise<MapNote> {
  const response = await apiFetch(
    `/api/campaigns/${encodeURIComponent(campaignId)}/map-notes`,
    { method: "POST", body: JSON.stringify(input) },
  );
  const payload = await readJson<{ mapNote: MapNote }>(response);
  return payload.mapNote;
}

export async function updateCampaignMapNote(
  campaignId: string,
  mapNoteId: string,
  input: UpdateMapNoteInput,
): Promise<MapNote> {
  const response = await apiFetch(
    `/api/campaigns/${encodeURIComponent(campaignId)}/map-notes/${encodeURIComponent(mapNoteId)}`,
    { method: "PATCH", body: JSON.stringify(input) },
  );
  const payload = await readJson<{ mapNote: MapNote }>(response);
  return payload.mapNote;
}

export async function deleteCampaignMapNote(
  campaignId: string,
  mapNoteId: string,
): Promise<void> {
  const response = await apiFetch(
    `/api/campaigns/${encodeURIComponent(campaignId)}/map-notes/${encodeURIComponent(mapNoteId)}`,
    { method: "DELETE" },
  );
  await readJson<{ ok: boolean }>(response);
}
